import MyAppointmentsStateService from '../services/my_appointment_state_service';

export interface IButtonConfig {
  isDisabled: boolean;
  action: () => void;
  buttonText: string;
}

export class AppointmentButtonServant {
  private _isDisabled: boolean;
  private _action: () => void;
  private _buttonText: string;

  constructor(private ngMyAppointmentsStateService: MyAppointmentsStateService) {}

  get isDisabled() {
    return this._isDisabled;
  }

  set isDisabled(disabled: boolean) {
    this._isDisabled = disabled;
  }

  get action() {
    return this._action;
  }

  set action(action: () => void) {
    this._action = action;
  }

  get buttonText() {
    return this._buttonText;
  }

  set buttonText(text: string) {
    this._buttonText = text;
  }

  configButton(buttonConfig: IButtonConfig) {
    this.action = buttonConfig.action;
    this.buttonText = buttonConfig.buttonText;
    this.isDisabled = buttonConfig.isDisabled;
  }

  get defaultConfigs(): IButtonConfig {
    return {
      isDisabled: !this.ngMyAppointmentsStateService.currentStep.isCompleted,
      action: () => this.ngMyAppointmentsStateService.next(),
      buttonText: 'Continue to Next Step'
    };
  }

  setDefaults() {
    this.configButton(this.defaultConfigs);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/servants/appointment_button_servant.ts